export default __webpack_public_path__ + "static/media/item-sourcing-pic2.430a62d0.png";